module.exports = __webpack_public_path__ + "static/media/27OCHA4.f6690267.jpg";